import React from "react";
const UserRole = React.lazy(() => import('./UserRole'));

export const userRolePagesConfig = [
    {
        path: '/apps/userrole',
        element:<UserRole />,
        roleAccess: ['ADMIN_TOOLS'],
    },
    {
        path: '/apps/userrole/:page',
        element: <UserRole />,
        roleAccess: ['ADMIN_TOOLS'],
    },
];